<template>
  <div v-if="!isLoading">
    <SearchTagEmptyMessage
      v-if="!hasTotalCount && !isDataLoading"
      :page-type="pageType"
    />
    <template v-else>
      <DynamicSectionLoader
        v-for="(sectionInfo, index) in bandList"
        :key="`${sectionInfo.title}_${$route.name}_${index}`"
        :section-info="sectionInfo"
      />
    </template>
  </div>
</template>

<script>
import _ from 'lodash'
import { postSearchTagBand } from '@/common/utils/request'
import { setTransactionKeyToStorage } from '@/common/utils/storage.util'
import SearchTagEmptyMessage from '@/components/search/view/SearchTagEmptyMessage'
import DynamicSectionLoader from '@/components/container/DynamicSectionLoader'

export default {
  name: 'SearchTagMultiBand',
  components: {
    SearchTagEmptyMessage,
    DynamicSectionLoader
  },
  props: {
    pageType: {
      type: String,
      default: ''
    },
    tagDataList: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      bandList: [], // object []
      totalCount: 0, // 전체 검색 총 겟수 | number
      limit: 20, // number
      offset: 0, // number
      isLoading: true, // 초기 모든 데이터 로딩 여부 | boolean
      isDataLoading: true // 비동기 데이터 로딩 | boolean
    }
  },
  computed: {
    hasTotalCount () {
      return this.totalCount > 0
    }
  },
  created () {
    this.resetData()
    this.fetchData()
  },
  methods: {
    getContentType () {
      const contentTypeMap = { broadcast: 'vod', movie: 'movie', vod: 'vod' }
      return contentTypeMap[this.pageType]
    },
    setBandData (data) {
      setTransactionKeyToStorage(data)
      this.bandList = _.get(data, 'multisectionlist', [])
      this.totalCount = Number(data?.totalcount) || 0
    },
    async fetchData () {
      this.isDataLoading = true

      try {
        const defaultParams = { limit: this.limit, offset: this.offset, searchtags: this.tagDataList, version: 2 }
        const contentType = this.getContentType()
        const { data } = await postSearchTagBand(_.assign({}, defaultParams, { type: contentType }))
        this.setBandData(data)
      } catch (error) {
        console.error(error)
      } finally {
        this.isDataLoading = false
        this.isLoading = false
      }
    },
    resetData () {
      this.bandList = []
      this.offset = 0
    }
  },
  watch: {
    $route (newRoute) {
      console.log('newRoute change band', newRoute)
      this.resetData()
      this.fetchData()
    }
  }
}
</script>
